const faqs = [
  {
    question: 'Quanto custa o envidraçamento de uma sacada em São Paulo?',
    answer:
      'O valor depende do tamanho da sacada, tipo de vidro (temperado ou laminado), acabamento e acessórios escolhidos. Em média, envidraçamentos articulados sem roldana em São Paulo variam de R$ 3.500 a R$ 12.000. Solicite um orçamento personalizado e gratuito pelo WhatsApp — vamos até o local para medição precisa.',
  },
  {
    question: 'O envidraçamento de sacada precisa de aprovação do condomínio?',
    answer:
      'Sim, em praticamente todos os condomínios de São Paulo é necessário aprovação da assembleia ou do síndico antes da instalação. A Vidros Thelux fornece projeto técnico, memorial descritivo e todos os documentos necessários para apresentação ao condomínio, facilitando o processo de aprovação.',
  },
  {
    question: 'Qual a diferença entre vidro temperado e laminado para sacada?',
    answer:
      'O vidro temperado é mais resistente a impactos e, em caso de quebra, se desfragmenta em pequenos cacos sem pontas afiadas. O laminado é composto por duas camadas de vidro com película intermediária, o que mantém os fragmentos grudados mesmo quebrando. Para sacadas altas e regiões com ventos fortes em São Paulo, recomendamos o laminado por maior segurança.',
  },
  {
    question: 'Vocês atendem na minha região de São Paulo?',
    answer:
      'Atendemos todos os bairros de São Paulo capital e Grande SP, incluindo Zona Sul (Moema, Brooklin, Jardins), Zona Oeste (Morumbi, Butantã), Zona Norte (Santana, Barra Funda), Zona Leste (Tatuapé, Anália Franco), Centro e região metropolitana (Guarulhos, Osasco, Santo André, São Bernardo). Consulte pelo WhatsApp para confirmar atendimento na sua região.',
  },
  {
    question: 'Qual o prazo de instalação do envidraçamento de sacada?',
    answer:
      'Após aprovação do orçamento e do condomínio, o prazo médio é de 15 a 25 dias úteis em São Paulo. Esse prazo inclui fabricação sob medida dos vidros e perfis, além da marcação da equipe de instalação. Para obras com urgência, consulte nossa equipe sobre possibilidade de prazo reduzido.',
  },
  {
    question: 'O fechamento de sacada articulado sem roldana é seguro?',
    answer:
      'Sim, é extremamente seguro quando fabricado e instalado corretamente. Nosso sistema articulado sem roldana utiliza guias de alumínio de alta resistência e vidro temperado ou laminado certificado. Todo o projeto segue a norma NBR 7199 de vidros em edificações, garantindo segurança estrutural e proteção contra ventos e impactos.',
  },
  {
    question: 'Vocês dão garantia no envidraçamento de sacada?',
    answer:
      'Sim, oferecemos garantia de 5 anos nos componentes estruturais e 1 ano nos acessórios do sistema articulado. Nossa equipe de manutenção atua em toda São Paulo para eventuais ajustes ou reparos pós-instalação. O atendimento de pós-venda é feito via WhatsApp com resposta em até 24 horas.',
  },
  {
    question: 'Posso parcelar o envidraçamento da sacada?',
    answer:
      'Sim, trabalhamos com diversas formas de pagamento. Aceitamos PIX, transferência bancária, cartão de crédito em até 12x e também condições especiais para pagamento à vista. Além disso, nosso programa "Primeiros Clientes" oferece orçamento travado por 10 meses, protegendo você contra reajustes de preço.',
  },
];

export default function FAQSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-bold tracking-widest text-primary-600 uppercase mb-3">
            TIRE SUAS DÚVIDAS
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
            Perguntas Frequentes sobre Envidraçamento de Sacada em São Paulo
          </h2>
          <p className="text-foreground-600 mt-3 text-sm max-w-xl mx-auto">
            Reunimos as principais dúvidas de quem está planejando fechar a sacada no apartamento ou casa em São Paulo.
          </p>
        </div>

        <div className="space-y-3" itemScope itemType="https://schema.org/FAQPage">
          {faqs.map((faq, idx) => (
            <details
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden open:border-primary-200 transition-colors"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none select-none">
                <span className="font-semibold text-foreground-900 text-sm pr-4" itemProp="name">
                  {faq.question}
                </span>
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 group-open:bg-primary-100 text-foreground-500 group-open:text-primary-600 shrink-0 transition-all">
                  <i className="ri-add-line text-lg group-open:hidden"></i>
                  <i className="ri-subtract-line text-lg hidden group-open:block"></i>
                </div>
              </summary>
              <div
                className="px-5 pb-5 text-foreground-600 text-sm leading-relaxed"
                itemScope
                itemProp="acceptedAnswer"
                itemType="https://schema.org/Answer"
              >
                <p itemProp="text">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-foreground-500 text-sm mb-3">
            Ainda tem dúvidas? Fale diretamente com nossos consultores técnicos.
          </p>
          <a
            href="https://wa.me/5511986765185?text=Ol%C3%A1%2C%20tenho%20uma%20d%C3%BAvida%20sobre%20envidra%C3%A7amento%20de%20sacada."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-bold px-6 py-3 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-lg"></i>
            </div>
            Tirar Dúvida pelo WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}